import { useDispatch, useSelector } from "react-redux";

import type { RootState } from "./rootReducers";
import type { AppDispatch } from "./store";

// Use this instead of plain `useDispatch` and `useSelector` this is for type safety
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
